<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/">
        <i class="fa fa-home"></i>
        Home
      </b-breadcrumb-item>
      <b-breadcrumb-item to="/idts">Interdepartmental Transfers</b-breadcrumb-item>
      <b-breadcrumb-item to="/idts">{{ type }} IDTs</b-breadcrumb-item>
      <b-breadcrumb-item active>
        {{ sl }}-{{ sa }}
      </b-breadcrumb-item>
    </b-breadcrumb>

    <AppLoadingContainer :predicate="isLoading">
      <form @submit.prevent="onSubmit()">
        <div class="card">
          <div class="bg-dark card-header text-white">Edit {{ type }} IDT</div>
          <div class="card-body">
            <div v-if="accountId == null || (accountIsActive != undefined && accountIsActive != null && !accountIsActive) || (accountIsFrozen != undefined && accountIsFrozen != null && accountIsFrozen) || organizationId == null || organizationCode == null || (organizationIsActive != null && !organizationIsActive)" >
              <fieldset class="border p-3 mr-2">
                  <legend class="w-auto h5">
                      <i class="fa fa-exclamation-circle" style="color: red !important;display:inline;padding-right:5px;"></i>
                      <span>Sync Data Issues</span>
                  </legend>
                  <b-row v-if="accountId == null || (accountIsActive != undefined && accountIsActive != null && !accountIsActive) || (accountIsFrozen != undefined && accountIsFrozen != null && accountIsFrozen)">
                      <b-col v-if="accountId == null">
                          <div v-if="accountId == null" class="col-md-3">
                              <label>Account</label>
                              <div class="pl-4">{{sl}}-{{sa}}</div>
                          </div>
                      </b-col>
                      <b-col v-if="accountId == null">
                          <div v-if="accountId == null" class="col-md-3">
                              <label>Account BIMS Record Status</label>
                              <div class="pl-4">Missing</div>
                          </div>
                      </b-col>
                      <b-col v-if="(accountIsActive != undefined && accountIsActive != null && !accountIsActive) || (accountIsFrozen != undefined && accountIsFrozen != null && accountIsFrozen)">
                          <div class="col-md-3">
                              <label>Account Status</label>
                              <div class="pl-4">{{ !accountIsActive ? "Inactive" : accountIsFrozen ? "Frozen" : "" }}</div>
                          </div>
                      </b-col>
                  </b-row>
                  <b-row v-if="organizationId == null || organizationCode == null || (organizationIsActive != null && !organizationIsActive)">
                      <b-col v-if="organizationCode == null || organizationId == null">
                          <div class="col-md-3">
                              <label>Organization Code</label>
                              <div class="pl-4">{{ organizationCode == null ? "-" : organizationCode }}</div>
                          </div>
                          <div v-if="organizationId == null" class="col-md-3">
                              <label>Organization BIMS Record Status</label>
                              <div class="pl-4">Missing</div>
                          </div>
                      </b-col>
                      <b-col v-if="organizationIsActive != null && !organizationIsActive">
                          <div class="col-md-3">
                              <label>Organization Status</label>
                              <div class="pl-4">Inactive</div>
                          </div>
                      </b-col>
                  </b-row>
              </fieldset>
                <br>
          </div>
          <div class="row">
            <b-col col lg="3" md="4" class="form-group">
                <label for="accountId">Account</label>
                <select class="form-control" v-model="updateAccountId">
                    <option :value="null" disabled>--Select Account--</option>
                    <option :key="account.id" :value="account.id" v-for="account in accounts">{{account.sl}}-{{account.sa}}</option>
                </select>
            </b-col>
            <b-col col lg="3" md="4" class="form-group">
                <label for="updateOrganizationId">Department</label>
                <select class="form-control" v-model="updateOrganizationId">
                    <option :value="null" disabled>--Select Department--</option>
                    <option :key="organization.id" :value="organization.id" v-for="organization in organizations">{{ organization.code }}</option>
                </select>
            </b-col>
            <div class="col form-group">
                <label for="description">Description</label>
                <input class="form-control"
                        v-model="updateDescription"/>
            </div>
            <div class="col-md-4 col-sm-12 form-group">
              <label for="updateAmountCharged">Amount Charged</label>
              <input class="form-control" v-model.number="updateAmountCharged" placeholder="Amount Charged" />
            </div>
          </div>
          </div>
          <div class="card-footer d-print-none text-right">
            <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Submit</button>
            <RouterLink :to="{ name: 'IDTs' }" class="btn btn-danger">Back</RouterLink>
          </div>
        </div>
      </form>
    </AppLoadingContainer>
  </div>
</template>

<script>
import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
import InterdepartmentalTransfersService from "@/services/InterdepartmentalTransfersService";
import { ToastType } from "@/services/models/shared/ToastType";
import AccountsService from '@/services/AccountsService';
import OrganizationService from '@/services/OrganizationService';

export default {
  components: {
    AppLoadingContainer
  },
  data() {
    return { 
      accounts: [],
      organizations: [],
      updateAccountId: null,
      updateOrganizationId: null,
      updateAmountCharged: null,
      updateDescription: null,
      isSubmitting: false,
      isLoading: true,
      displayOrganizationCode: null
    };
  },
  props: {
    type: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    accountId: {
      type: String,
      required: false
    },
    organizationId: {
      type: String,
      required: false
    },
    sl: {
      type: String,
      required: true
    },
    sa: {
      type: String,
      required: true
    },
    organizationCode: {
      type: String,
      required: false
    },
    accountIsFrozen: {
      type: Boolean,
      required: false
    },
    accountIsActive: {
      type: Boolean,
      required: false
    },
    organizationIsActive: {
      type: Boolean,
      required: false
    },
    amountCharged: {
      type: Number,
      required: false
    },
    description: {
      type: String,
      required: false
    }
  },
  methods: {
    onSubmit() {
      const vm = this;

      vm.isSubmitting = true;
      InterdepartmentalTransfersService.updateIDT({
        id: vm.id,
        accountId: vm.updateAccountId,
        organizationId: vm.organizationId,
        amountCharged: vm.updateAmountCharged,
        description: vm.updateDescription
      })
        .then(() => {
          vm.alert(ToastType.Success, 'The IDT was successfully updated');
          vm.$router.replace({ name: 'IDTs' });
        })
        .catch(() => {
          vm.alert(ToastType.Danger, 'IDT could not be updated');
        })
        .finally(() => {
          vm.isSubmitting = false;
        });
    },

    loadAccounts () {
      const vm = this;

      AccountsService.getAccounts({
        returnAll: true,
        page: 1,
        pageSize: 10,
        isDeleted: false
      })
          .then(response => {
              vm.accounts = response.data;
          })
          .catch(error => {
              vm.alert(ToastType.Danger, error.response.data)
          })
    },

    loadOrganizations () {
      const vm = this;

      OrganizationService.getOrganizationList({
        onlyShowActive: true,
        returnAll: true
      })
          .then(response => {
              vm.organizations = response.data;
          })
          .catch(error => {
              vm.alert(ToastType.Danger, error.response.data)
          })
    }
  },
  created() {
    this.loadAccounts();
    this.loadOrganizations();
    this.updateAmountCharged = this.$route.params.amountCharged;
    this.updateAccountId = this.$route.params.accountId;
    this.updateOrganizationId = this.$route.params.organizationId;
    this.updateDescription = this.$route.params.description;
    this.displayOrganizationCode = this.$route.params.organizationCode;
    this.isLoading = false;
  }
};
</script>

